import {Button, Col, Container, Form, Row} from "react-bootstrap";
import {useState} from "react";
import {login} from "../service/UserService";
import {Link} from "react-router-dom";

export function geturl(endpoint) {
    let currentHostname = window.location.hostname
    return 'https://' + currentHostname.replace('backoffice', endpoint);
}

export default function Login() {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [message, setMessage] = useState()
    const [isLoading, setIsLoading] = useState(false)

    function handleFormSubmit(event) {
        event.preventDefault()
        window.grecaptcha.enterprise.ready(async () => {
            const token = await window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTHA, {action: 'LOGIN'});
            setMessage(null)
            setIsLoading(true)
            login(username, password, token).then(response => {
                if (response.status === 200) {
                    response.json().then(result => {
                        localStorage.setItem("cosToken", result.token)
                        window.location.href = "/"
                    })
                } else {
                    setMessage("Login failed, please retry")
                }
            }).finally(() => setIsLoading(false))
        });

    }

    return (
        <div style={{height: "600px"}}>
            <Container style={{maxWidth: "300px", position: "relative", top: "25%"}}>
                <Row>
                    <Col><img width={"300px"} style={{marginLeft: "10px"}}
                              src={"/" + process.env.PUBLIC_URL + "UrbanAideBanner.svg"} alt={"UrbanAide Logo"}/></Col>
                </Row>
                <Row>
                    <Col>
                        <h3>Back Office</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span style={{color: "red"}}>{message}</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form onSubmit={handleFormSubmit}>
                            <Form.Group className="mb-3" controlId="formBasicUsername">
                                <Form.Label>Username</Form.Label>
                                <Form.Control type="text" placeholder="Enter username" required value={username}
                                              name="username"
                                              onChange={(e) => setUsername(e.target.value)}/>
                                <Form.Text className="text-muted">
                                    Enter your username.
                                </Form.Text>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" placeholder="Password" required value={password}
                                              name="password"
                                              onChange={(e) => setPassword(e.target.value)}/>
                                <Form.Text className="text-muted">
                                    Enter your password.
                                </Form.Text>
                            </Form.Group>
                            <Button variant="primary" type="submit" disabled={isLoading}>
                                {isLoading ? "Loading..." : "Login"}
                            </Button>

                        </Form>
                    </Col>
                </Row>
                <Row>
                    <Col style={{textAlign: "left", fontSize: "12px", marginTop: "30px"}}>
                        Can't login? Try <br/>
                        <a href={geturl('manage')}>Agent Portal</a><br/>
                        <a href={geturl('workers')}>Worker Portal</a>
                    </Col>
                </Row>
                <Row>
                    <Col style={{textAlign: "left", fontSize: "12px", marginTop: "30px"}}>
                        This site is protected by reCAPTCHA and the Google
                        <a href="https://policies.google.com/privacy"> Privacy Policy</a> and
                        <a href="https://policies.google.com/terms"> Terms of Service</a> apply.
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

